export default {
    ChannelThirdPartyPlatform: {
      Add: '新增',
      Account: '账号',
      code: '账户编码',
      API: 'api地址',
      app_Key: 'app_key',
      appSecret: '平台应用密钥',
      name: '平台应用名称',
      type: '平台应用类型',
      Authorizable: '可授权账号',
      address: '平台授权地址',
      Number: '合作编号',
      Callback: '回调地址',
      traffic: '证书流量',
      Channel: '渠道编码',
      Creator: '创建者',
      Creation: '创建日期',
      Currency: '币种',
      Delete: '删除状态',
      Last: '上次更新日期',
      by: '上次更新者',
      Other: '其他地址',
      Development: '开发平台地址',
      Project: '项目',
      Remarks: '备注',
      Status: '状态',
      System: '系统标识',
      Tax: '税号',
      Normal: '正常',
      Exception: '异常',
      third: '新增三方平台',
    },
};
